// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__32qnY","leftBlock":"style_leftBlock__2oDoT","avatar":"style_avatar__RFHQ0","transcript":"style_transcript__1lTjQ","footer":"style_footer__36bCb"};